import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { NetworkState } from '../../constants';

type OfflineState = {
    networkState: NetworkState;
};

const initialState: OfflineState = {
    networkState: NetworkState.ONLINE,
};

const offlineSlice = createSlice({
    name: 'offline',
    initialState,
    reducers: {
        resetOfflineState() {
            return initialState;
        },
        setNetworkState(state, action: PayloadAction<NetworkState>) {
            state.networkState = action.payload;
        },
    },
});

export const networkStateOnline = createAction('conference/offline/networkStateOnline');
export const networkStateOffline = createAction('conference/offline/networkStateOffline');
export const { resetOfflineState, setNetworkState } = offlineSlice.actions;
export const offlineReducer = offlineSlice.reducer;
